import React , {Component} from 'react';
import Carousel from 'react-bootstrap/Carousel'
import Spinner from 'react-bootstrap/Spinner'
import Toast from 'react-bootstrap/Toast'
import Nav from 'react-bootstrap/Nav'
import OtherNews from './OtherNews';
import nonImage from './nonImage.png'
import './MyNews.css';
import dataService from '../../services/dataService';
import { Link } from 'react-router-dom';

class MyNews extends Component {
	_isMounted = false;
	constructor(props){
		super(props);
		this.state = {
			category: 'general',
			url : 'https://newsapi.org/v2/top-headlines?country=il&apiKey=abc72145994a45f19cd1781fe040f011&category=',
			data : {},
			toastDisplay : true
		}
	}
	componentDidMount() {
		this._isMounted = true;
		const category = this.props.category;
		this.onSelectCategory(category);
	}
	
	componentWillUnmount() {
   		 this._isMounted = false;
  	}
	onCloseToast = () => {
		this.setState({toastDisplay : false});
	}
	onSelectCategory = (selectedCategory) => {
		const url = this.state.url + selectedCategory;
		const req = new Request(url);
		fetch(req).then(response => response.json())
		.then(newData=>{
			if (this._isMounted && newData.status!=='error'){
				this.setState({data : newData})
			} else {
				let jsonData = dataService(selectedCategory);
				this.setState({data : jsonData})
			}
		}).catch((error)=>{
			let jsonData = dataService(selectedCategory);
			this.setState({data : jsonData})
		});
		this.setState({category : selectedCategory})
	}
	onLoginBtnClick = (event) => {
		if (event === 'login')
			 this.props.route.history.push("/Login")
		else this.props.route.history.push("/Register")
	}

	render() {
		if (!this.props.isSignedIn) {
			this.props.route.history.push('/');
			}
		if (!this.state.data.articles) return <Spinner animation="border" />;
		
			var news = this.state.data.articles;
			let newsImage = nonImage;
			var topNews = [];
				for (let index = 0 ; index<5 ; index++){
					topNews.push(news[index]);
				}
			const newsArray = topNews.map((user,i) => {
				let newsImage = nonImage;
				if (topNews[i].urlToImage) newsImage = topNews[i].urlToImage;
				return ( 
					  <Carousel.Item onClick ={()=>window.open(news[i].url, '_blank').focus()} key = {i}>
					    <img
					      id = "mainImg"
					      src={newsImage}
					      alt="slide"
					    />

					    <Carousel.Caption>
					      	<h3 id = "mainTitles">{topNews[i].title}</h3>
					      	<p id = "mainDesc">{topNews[i].description}</p>
					    </Carousel.Caption>
					  </Carousel.Item>
					);
			});
		//else newsApi is working ...
		return (
			<div id = 'myNewsContainer'>
				<Toast id="toastDisplay" show = {this.state.toastDisplay} onClose = {this.onCloseToast}>
	  					<Toast.Header>
						    <img src="holder.js/20x20?text=%20" className="rounded mr-2" alt="" />
						    <strong className="mr-auto">YourNews</strong>
						    <small>now</small>
				  		</Toast.Header>
						  {this.props.isSignedIn === true ? <Toast.Body>Hello, {this.props.username} ! your'e logged in.</Toast.Body>
						  : <Toast.Body>Hello, {this.props.username} ! your'e in limited version.
						 <br></br><Link to = "/Login"> Login now</Link></Toast.Body>}
				
				</Toast>
					<Carousel id = "mainArticles" >
						  {newsArray}
					</Carousel>

				<div id = "navContainer" style = {{margin :'20px'}}>
					{this.props.isSignedIn === true ?
					<Nav id = "navGroup" variant="pills" defaultActiveKey= {this.props.category}
						onSelect={this.onSelectCategory}>
						  <Nav.Item>
						    <Nav.Link eventKey="general">General</Nav.Link>
						  </Nav.Item>
							<Nav.Item>
								<Nav.Link eventKey="sports" >Sports</Nav.Link>
							</Nav.Item>
							<Nav.Item>
								<Nav.Link eventKey="technology">Technology</Nav.Link>
							</Nav.Item>
							<Nav.Item>
								<Nav.Link eventKey="entertainment">Entertainment</Nav.Link>
							</Nav.Item>
								<Nav.Item>
								<Nav.Link eventKey="business">Business</Nav.Link>
							</Nav.Item> 	
					</Nav> : (
						<Nav id = "navGroup" variant="pills" defaultActiveKey= {this.props.category}
						onSelect={this.onSelectCategory}>
						<Nav.Item>
							<Nav.Link eventKey="general">General</Nav.Link>
						</Nav.Item>
							<Nav.Item>
								<Nav.Link eventKey="sports" disabled >Sports</Nav.Link>
							</Nav.Item>
							<Nav.Item>
								<Nav.Link eventKey="technology" disabled>Technology</Nav.Link>
							</Nav.Item>
							<Nav.Item>
								<Nav.Link eventKey="entertainment" disabled>Entertainment</Nav.Link>
							</Nav.Item>
								<Nav.Item>
								<Nav.Link eventKey="business" disabled>Business</Nav.Link>
							</Nav.Item> 	
					</Nav>)}
				</div>
				<OtherNews news = {this.state.data.articles} isSignedIn = {this.props.isSignedIn} onLoginBtnClick={this.onLoginBtnClick}/>
			</div>
		);
	
	}
}
export default MyNews;